import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { UserService } from '../../../services/user/user.service';
import { AppModulesEnum, RoleAccessLevels, WorkloadUserRolesEnum } from '../../../types/user/user.types';

export const moduleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const requiredModule: AppModulesEnum = route.data?.['module'];
  const requiredRole: WorkloadUserRolesEnum = route.data?.['role'];

  const userService = inject(UserService);

  return userService.get().pipe(
    map((loggedUser) => {
      const userPermissions = loggedUser.permissions.find(
        (permission) => permission.module === requiredModule
      );
      if (userPermissions && requiredRole) {
        const userRole = userPermissions?.role;
        return userRole && RoleAccessLevels[userRole] >=
                    RoleAccessLevels[requiredRole];
      }
      return !!userPermissions;
    })
  );
};
